import { render } from "./saleconsumptionlist.vue?vue&type=template&id=62f71532&scoped=true"
import script from "./saleconsumptionlist.vue?vue&type=script&lang=js"
export * from "./saleconsumptionlist.vue?vue&type=script&lang=js"

import "./saleconsumptionlist.vue?vue&type=style&index=0&id=62f71532&scoped=true&lang=css"
import "./saleconsumptionlist.vue?vue&type=style&index=1&id=62f71532&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f71532"]])

export default __exports__